export default function SearchBar({ value }: { value: string }) {
  return (
    <form className="flex flex-col items-center gap-2 p-4 md:flex-row md:gap-4">
      <div className="flex w-full flex-1 items-center gap-2 rounded-md border-2 border-gray-300 p-2 focus-within:ring-2 focus-within:ring-blue-500">
        {locationIcon}

        <input
          type="text"
          aria-invalid="false"
          id="text-input-location"
          name="location"
          aria-haspopup="listbox"
          enterKeyHint="search"
          autoCapitalize="none"
          autoComplete="off"
          aria-autocomplete="list"
          aria-controls="text-input-location"
          placeholder="city, state or zip code"
          aria-label="Enter location to search for jobs"
          maxLength={500}
          className="flex-1 focus:outline-none"
          defaultValue={value}
        />
      </div>
      <button
        type="submit"
        aria-label="Search for Anesthesiologist jobs"
        className="flex items-center justify-center gap-2 rounded-md bg-blue-500 px-4 py-2 font-medium text-white transition duration-300 hover:bg-blue-600"
      >
        {magnifyingGlassIcon}
        Search Jobs
      </button>
    </form>
  );
}

const locationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="h-6 w-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
    />
  </svg>
);

const magnifyingGlassIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="h-6 w-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
    />
  </svg>
);
